export const DropdownIcon = ({ color }) => (
  <svg viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 0 4 4 0 0h8Z" fill={color ? color : "#030302"} />
  </svg>
);